/* Paola & Joy — Hero Banner countdown + auto-swap
   States:
     1. schedule disabled              → Always-on
     2. now < startsAt                 → Always-on (sale not started yet)
     3. startsAt <= now < endsAt       → Sale banner + optional countdown
     4. now >= endsAt                  → Always-on (sale ended)
*/
(function () {

  /* Robustly parse YYYY-MM-DDTHH:MM (no seconds) or full ISO strings.
     Without a timezone suffix, treated as local time.
     Appending :00 ensures cross-browser compatibility (Safari rejects HH:MM). */
  function parseDate(str) {
    if (!str) return NaN;
    // Append :00 seconds if string ends at HH:MM
    var s = str.replace(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})$/, '$1:00');
    var ts = new Date(s).getTime();
    return ts;
  }

  // Keep track of running timers so we can clear them on section reload
  var timers = {};

  function init(wrap) {
    if (!wrap) return;
    var id = wrap.id || 'pj-hero';

    // Clear any previously running timer for this section
    if (timers[id]) { clearInterval(timers[id]); delete timers[id]; }
    wrap.dataset.pjInit = '1';

    var enabled       = wrap.dataset.scheduleEnabled === 'true';
    var startsAtStr   = wrap.dataset.startsAt  || '';
    var endsAtStr     = wrap.dataset.endsAt    || '';
    var showCountdown = wrap.dataset.showCountdown === 'true';
    var sale          = wrap.querySelector('.pj-hero--sale');
    var alwaysOn      = wrap.querySelector('.pj-hero--alwayson');
    var countdownEl   = wrap.querySelector('[data-pj-countdown]');

    function show(el, on) {
      if (!el) return;
      if (on) el.classList.remove('is-hidden');
      else    el.classList.add('is-hidden');
    }

    function showAlwaysOn() {
      show(sale, false);
      show(alwaysOn, true);
      if (countdownEl) countdownEl.style.display = 'none';
    }

    function showSale() {
      show(sale, true);
      show(alwaysOn, false);
      if (countdownEl) countdownEl.style.display = '';
    }

    // Schedule disabled → Always-on only, no timer needed
    if (!enabled || !endsAtStr) {
      showAlwaysOn();
      return;
    }

    var startTs = parseDate(startsAtStr);  // NaN if blank
    var endTs   = parseDate(endsAtStr);

    // If end date is unparseable, bail out to Always-on
    if (isNaN(endTs)) { showAlwaysOn(); return; }
    // Unparseable start = treat as "no start gate" (sale always ready)
    if (isNaN(startTs)) startTs = 0;

    function tick() {
      var now = Date.now();

      // Before sale starts
      if (startTs > 0 && now < startTs) {
        showAlwaysOn();
        return true; // keep ticking — will flip when start arrives
      }

      // After sale ends
      if (now >= endTs) {
        showAlwaysOn();
        return false; // stop ticking
      }

      // Sale is live
      showSale();

      if (showCountdown && countdownEl) {
        var diff = Math.max(0, endTs - now);
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        function setN(sel, n) {
          var el = countdownEl.querySelector(sel);
          if (el) el.textContent = n < 10 ? '0' + n : String(n);
        }
        setN('[data-cd="d"]', d);
        setN('[data-cd="h"]', h);
        setN('[data-cd="m"]', m);
        setN('[data-cd="s"]', s);
      }

      return true; // keep ticking
    }

    if (!tick()) return; // already resolved on first check, no timer needed
    timers[id] = setInterval(function () {
      if (!tick()) {
        clearInterval(timers[id]);
        delete timers[id];
      }
    }, 1000);
  }

  function boot() {
    document.querySelectorAll('.pj-hero-wrap').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when Shopify theme editor changes settings or reloads section
  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target.querySelector('.pj-hero-wrap');
    if (w) init(w);
  });
})();
